import { render, staticRenderFns } from "./ShoppingModel.vue?vue&type=template&id=16ab01b9&scoped=true"
import script from "./ShoppingModel.vue?vue&type=script&lang=js"
export * from "./ShoppingModel.vue?vue&type=script&lang=js"
import style0 from "./ShoppingModel.vue?vue&type=style&index=0&id=16ab01b9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ab01b9",
  null
  
)

export default component.exports